module.exports = __webpack_public_path__ + "media/img/decorations/values-after-img-b19a26a3ee1686a3ef208ff0041d7d29.svg";